export class ScaleError extends Error {
	constructor(message: string) {
		super(message)
	}
}
